import { useSearchParams, Link } from 'react-router-dom';
import { useMemo } from 'react';
import { videoSites } from '@/mocks/videoData';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function SearchPage() {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q') || '';

  const results = useMemo(() => {
    if (!query.trim()) return [];
    const q = query.toLowerCase();
    return videoSites.filter(
      (site) =>
        site.name.toLowerCase().includes(q) ||
        site.description.toLowerCase().includes(q) ||
        site.tags.some((tag) => tag.toLowerCase().includes(q))
    );
  }, [query]);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="max-w-7xl mx-auto px-4 md:px-6 py-6">
        <Breadcrumb items={[{ label: '首页', href: '/' }, { label: `搜索：${query}` }]} />

        <div className="mb-8">
          <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
            搜索结果
          </h1>
          <p className="text-sm text-foreground-500">
            关键词 &quot;{query}&quot; 共找到 {results.length} 个相关站点
          </p>
        </div>

        {results.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
            {results.map((site) => (
              <Link
                key={site.slug}
                to={`/article/${site.slug}`}
                className="group block bg-background-50 border border-background-200/70 rounded-lg p-5 hover:border-primary-300 transition-all duration-200"
              >
                <div className="flex items-start gap-3 mb-3">
                  <div className="w-11 h-11 flex-shrink-0 rounded-lg bg-gradient-to-br from-primary-100 to-accent-100 flex items-center justify-center overflow-hidden">
                    <img src={site.imageUrl} alt={site.name} className="w-full h-full object-cover" loading="lazy" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                      {site.name}
                    </h3>
                    <p className="text-xs text-foreground-400 mt-0.5">{site.visits} 访问</p>
                  </div>
                </div>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">{site.description}</p>
                <div className="flex items-center gap-2 flex-wrap">
                  {site.tags.map((tag) => (
                    <span key={tag} className="text-[10px] px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700">
                      {tag}
                    </span>
                  ))}
                </div>
              </Link>
            ))}
          </div>
        ) : (
          <div className="text-center py-20">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100">
              <i className="ri-search-line text-2xl text-foreground-400"></i>
            </div>
            <p className="text-foreground-500 mb-2">未找到与 &quot;{query}&quot; 相关的站点</p>
            <p className="text-sm text-foreground-400">请尝试其他关键词搜索</p>
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}